import functions from "./functions.js";

$(function() {

    const $form = $('.form-booking');
    const form = $form[0];

    if ( !form ) {
        return;
    }

    $(".booking-remove").on('click', e => {
        let unitId = $(e.target).attr('data-unitid'),
            cart = functions.getCookie('cart_data'),
            _cart = [];

        cart = cart ? JSON.parse(cart) : [];
;
        $.each(cart, function( key, item ) {
            if(item.unitId != unitId) {
                _cart.push(item);
            }
        });

        functions.setCookie('cart_data', JSON.stringify(_cart));
        location.reload();
    });

    const formatMoney = (n, c, d, t) => {
        var c = isNaN(c = Math.abs(c)) ? 2 : c,
            d = d == undefined ? "." : d,
            t = t == undefined ? "," : t,
            s = n < 0 ? "-" : "",
            i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
            j = (j = i.length) > 3 ? j % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    const itemTotal = (item, key) => {

        if ( ! +item.quantity) return 0;

        let itemTotal = 0.00;
        let price = 0.00;

        if (key == 'advance') {
            price = +item.advance;
        } else if (key == 'advanceConverted') {
            price = +item.advanceConverted;
        } else if (key == 'price') {
            price = +item.price;
        } else if (key == 'priceConverted') {
            price = +item.priceConverted;
        }

        if (item.paymentTypeId.key) {

            if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                itemTotal = +item.quantity * price;
            } else {
                itemTotal = price;
            }
        } else {
            itemTotal = +item.quantity * price;
        }

        return itemTotal;
    }

    let calc = [];
    $form.find("*[data-calc]").each(function (index) {
        let item = JSON.parse($(this).attr('data-calc'));
        item.inCalc = item.isOptional ? 0 : 1;
        calc.push(item);
    });


    $form.find('input[data-calc]').change(function (e) {
        let quantity = $(this).is(':checked') ? 1 : 0;
        let id = $(this).attr('id');
        let totalAmountConverted = 0;
        let totalAmount =  0;
        let advance =  0;
        let advanceConverted =  0;

        $.each(calc, function (key, item) {
            if ( ! item.onSpot) {
                if (id == item.id) {
                    item.quantity = quantity;
                }

                advance += itemTotal(item, 'advance');
                advanceConverted += itemTotal(item, 'advanceConverted');

                totalAmount += itemTotal(item, 'price');
                totalAmountConverted += itemTotal(item, 'priceConverted');
            }
        });

        $('.total').html(formatMoney(totalAmount, 2, ',', '.'));
        $('.total-converted').html(formatMoney(totalAmountConverted, 2, ',', '.'));

        $('.advance').html(formatMoney(advance, 2, ',', '.'));
        $('.advance-converted').html(formatMoney(advanceConverted, 2, ',', '.'));

        $('.remaining').html(formatMoney(totalAmount - advance, 2, ',', '.'));
        $('.remaining-converted').html(formatMoney(totalAmountConverted - advanceConverted, 2, ',', '.'));
    });

    $form.on('submit', e => {

        let calculation = { calc : { items : [], guests: '' } };

        $form.find('.is-invalid').removeClass('is-invalid');
        $form.find('input.required').each(function( index ) {
            let invalid = false;
            if ( $(this).attr('type') == 'checkbox' && ! $(this).is(":checked")) {
                invalid = true;
            } else if ( ! $(this).val()) {
                invalid = true;
            }

            if (invalid) {
                e.preventDefault();
                $(this).addClass('is-invalid');
                return;
            }
        });

        if ( ! $form.find('input[name="disclaimer"]:checked').length) {
            e.preventDefault();
            $form.find('input[name="disclaimer"]:visible').addClass('is-invalid');
            return;
        }

        if ($form.hasClass('booking')) {
            $form.find('input[data-calc]:checked').each(function( i ) {
                calculation.calc.items.push($(this).data('calc'));
            });

            calculation.calc.guests = calculation.calc.items[0].guests;
        } else {
            let urlData = functions.getUrlData(false),
                utc = new Date().toJSON().slice(0,10).replace(/-/g,'-');;
            urlData.price = urlData.total = 0.01;
            urlData.priceIn = urlData.totalIn = 0.0;
            urlData.guests = (urlData.persons || 2) + ',0,0';
            urlData.itemDefinitionId = 1;
            urlData.quantity = 1;
            urlData.dateFrom = urlData.dateFrom || utc;
            urlData.dateTo = urlData.dateTo || utc;
            calculation.calc.items.push(urlData);
            calculation.calc.guests = urlData.guests;
        }

        $form.append("<input type='hidden' name='reservationData' value='" +JSON.stringify(calculation)+ "'>");
        $form.append('<input type="hidden" name="requestId" value="' +Math.floor(Math.random() * ((9999999-1000000)+1) + 1000000)+ '" />');
        $form.append('<input type="hidden" name="status" value="Request" />');

     });

});